<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <img class="mt-4" width="500px" src="../../assets/images/wzl_navbar_logo.png" alt="WZL logo">
        <button class="btn mt-4 border" style="width: 500px;">WM_AUT SSO</button>
    </div>
</template>

<script setup>

import { useManageStore } from '@/stores/manage';
const manageStore = useManageStore();
manageStore.showNavbar = false;

</script>

<style scoped></style>